import { AWARDS } from "@/lib/site";

/**
 * Awards strip — showcases recognition (e.g. homecare.co.uk Top 20).
 * variant "light" = dark text on cream card (for use on light backgrounds)
 * variant "dark"  = cream text on translucent teal card (for use on dark hero)
 */
const AwardsStrip = ({
  variant = "light",
  eyebrow = "Award-winning care",
  heading = "Top 20 Home Care Providers · East of England",
}) => {
  const dark = variant === "dark";
  return (
    <div data-testid="awards-strip" className="w-full">
      <div className="text-center mb-8">
        <span
          className={`text-xs uppercase tracking-[0.22em] ${
            dark ? "text-[var(--ss-gold)]" : "text-[var(--ss-gold-dark)]"
          }`}
        >
          {eyebrow}
        </span>
        <h3
          className={`font-display text-3xl md:text-4xl mt-3 ${
            dark ? "text-[var(--ss-cream)]" : "text-[var(--ss-teal-800)]"
          }`}
        >
          {heading}
        </h3>
        <p
          className={`mt-2 text-sm ${
            dark ? "text-[var(--ss-cream)]/70" : "text-[var(--ss-ink-soft)]"
          }`}
        >
          Recognised by <a
            href="https://www.homecare.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-[var(--ss-gold)] underline-offset-2"
          >homecare.co.uk</a> — the UK's leading independent review platform for home care.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
        {AWARDS.map((a) => (
          <div
            key={a.year}
            data-testid={`award-${a.year}`}
            className={`flex items-center gap-4 md:gap-5 rounded-2xl border px-5 py-4 ${
              dark
                ? "border-[var(--ss-cream)]/15 bg-[var(--ss-teal-800)]/40"
                : "border-[var(--ss-line)] bg-[var(--ss-cream-soft)]"
            }`}
          >
            <img
              src={a.badge}
              alt={`${a.title} ${a.region} ${a.year} — ${a.source}`}
              className="w-16 md:w-20 h-auto shrink-0"
              loading="lazy"
            />
            <div className="leading-tight">
              <div
                className={`font-serif text-xl md:text-2xl ${
                  dark ? "text-[var(--ss-cream)]" : "text-[var(--ss-teal-800)]"
                }`}
              >
                {a.year}
              </div>
              <div
                className={`text-sm font-semibold ${
                  dark ? "text-[var(--ss-cream)]" : "text-[var(--ss-teal-800)]"
                }`}
              >
                {a.title}
              </div>
              <div
                className={`text-xs ${
                  dark ? "text-[var(--ss-cream)]/60" : "text-[var(--ss-ink-soft)]"
                }`}
              >
                {a.region}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AwardsStrip;
